import { Control, useWatch, useController } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Brain } from 'lucide-react';
// import { Check, X } from 'lucide-react'; // DÉSACTIVÉ - SMS désactivé
import { useState } from 'react';
// import { validateAndFormatPhone } from '@/utils/phoneValidation'; // DÉSACTIVÉ - Validation téléphone retirée

// Interface pour les référents recommandés
interface RecommendedReferent {
  experienceId?: string;
  experienceRef?: string;
  suggestedRole?: string;
  priority?: number;
  reasoning?: string;
}

// Interface pour les expériences
interface Experience {
  position?: string;
  company?: string;
}

// Interface pour les informations du candidat
interface CandidateInfo {
  name?: string;
  email?: string;
  phone?: string;
}

// Interface pour les données d'analyse IA
interface AIAnalysisData {
  candidateInfo?: CandidateInfo;
  targetPosition?: string;
  experiences?: Experience[];
  recommendedReferents?: RecommendedReferent[];
   
  evaluationCriteria?: any[];
}

// Composant pour les informations du candidat éditables
const CandidateInfoSection = ({ control, candidateInfo, targetPositionAI }: {
   
  control: Control<any>;
  candidateInfo: CandidateInfo;
  targetPositionAI: string;
}) => {
  const { field: nameField } = useController({
    name: 'candidate_name',
    control,
    defaultValue: candidateInfo?.name || ''
  });

  const { field: emailField } = useController({
    name: 'candidate_email',
    control,
    defaultValue: candidateInfo?.email || ''
  });

  // Champ téléphone conservé pour compatibilité mais non affiché
  useController({
    name: 'candidate_phone',
    control,
    defaultValue: candidateInfo?.phone || ''
  });

  const { field: positionField } = useController({
    name: 'target_position',
    control,
    defaultValue: targetPositionAI || ''
  });

  // DÉSACTIVÉ - SMS désactivé
  // Fonction de gestion du changement de téléphone (désactivée avec le champ téléphone)
  /*
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    phoneField.onChange(value);

    if (!value.trim()) {
      setPhoneError('Le numéro de téléphone est requis');
      setPhoneValid(false);
      return;
    }

    const result = validateAndFormatPhone(value);
    if (result.isValid && result.formatted) {
      phoneField.onChange(result.formatted);
      setPhoneError('');
      setPhoneValid(true);
    } else {
      setPhoneError(result.error || 'Format invalide');
      setPhoneValid(false);
    }
  };
  */

  return (
    <div className="space-y-4">
      <div className="text-gray-800 text-base font-medium font-bricolage">
        Informations du candidat
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <label className="text-neutral-400 text-sm font-medium font-bricolage">
            Nom complet
          </label>
          <input
            {...nameField}
            type="text"
            placeholder="Nom du candidat"
            className="w-full px-3 py-3.5 bg-white rounded-[10px] border border-neutral-400/20 text-gray-800 text-sm font-medium font-bricolage focus:border-teal-400 focus:ring-1 focus:ring-teal-400 focus:outline-none"
          />
        </div>
        <div className="space-y-2">
          <label className="text-neutral-400 text-sm font-medium font-bricolage">
            Email @
          </label>
          <input
            {...emailField}
            type="email"
            placeholder="email@exemple.com"
            className="w-full px-3 py-3.5 bg-white rounded-[10px] border border-neutral-400/20 text-gray-800 text-sm font-medium font-bricolage focus:border-teal-400 focus:ring-1 focus:ring-teal-400 focus:outline-none"
          />
        </div>
      </div>
      {/* CHAMP TÉLÉPHONE DÉSACTIVÉ - Pour réactiver, décommenter le bloc ci-dessous 
      <div className="space-y-2">
        <label className="text-neutral-400 text-sm font-medium font-bricolage">
          Numéro de téléphone *
        </label>
        <div className="relative">
          <input
            value={phoneField.value}
            onChange={handlePhoneChange}
            onBlur={phoneField.onBlur}
            type="tel"
            placeholder="+33612345678"
            className={`w-full px-3 py-3.5 pr-10 bg-white rounded-[10px] border text-gray-800 text-sm font-medium font-bricolage focus:ring-1 focus:outline-none ${
              phoneError 
                ? 'border-red-400 focus:border-red-400 focus:ring-red-400' 
                : phoneValid
                ? 'border-teal-400 focus:border-teal-400 focus:ring-teal-400'
                : 'border-neutral-400/20 focus:border-teal-400 focus:ring-teal-400'
            }`}
          />
          {phoneField.value && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              {phoneValid ? (
                <Check className="h-5 w-5 text-teal-400" />
              ) : (
                <X className="h-5 w-5 text-red-400" />
              )}
            </div>
          )}
        </div>
        {phoneError && (
          <p className="text-red-500 text-xs font-bricolage">{phoneError}</p>
        )}
        {!phoneError && phoneField.value && (
          <p className="text-neutral-400 text-xs font-bricolage">
            Format: +33612345678 (sans espaces)
          </p>
        )}
      </div>
      */}
      <div className="space-y-2">
        <label className="text-neutral-400 text-sm font-medium font-bricolage">
          Poste visé
        </label>
        <input
          {...positionField}
          type="text"
          placeholder="Poste recherché"
          className="w-full px-3 py-3.5 bg-white rounded-[10px] border border-neutral-400/20 text-gray-800 text-sm font-medium font-bricolage focus:border-teal-400 focus:ring-1 focus:ring-teal-400 focus:outline-none"
        />
      </div>
    </div>
  );
};

interface Step2AIValidationProps {
   
  control: Control<any>;
  aiAnalysisData: AIAnalysisData | null;
  onNext: () => void;
  onPrevious: () => void;
  onCancel: () => void;
  onSaveDraft: () => void;
  isSubmitting: boolean;
}

export const Step2AIValidation = ({
  control,
  aiAnalysisData,
  onNext,
  onPrevious,
}: Step2AIValidationProps) => {
  

  // État pour gérer la sélection des référents avec synchronisation du formulaire
  const { field: selectedReferentsField } = useController({
    name: 'selected_referents',
    control,
    defaultValue: []
  });
  
  const [selectedReferents, setSelectedReferents] = useState<string[]>(selectedReferentsField.value || []);

  // Surveiller les valeurs des champs pour validation
  const candidateName = useWatch({ control, name: 'candidate_name' });
  const candidateEmail = useWatch({ control, name: 'candidate_email' });
  // candidate_phone retiré de la validation
  const targetPosition = useWatch({ control, name: 'target_position' });

  // VALIDATION TÉLÉPHONE DÉSACTIVÉE - Le champ téléphone n'est plus requis
  // const isPhoneValid = !candidatePhone || validateAndFormatPhone(candidatePhone).isValid;

  // Vérifier si les champs essentiels sont remplis (téléphone retiré de la validation)
  const hasValidCandidateInfo = candidateName?.trim() && candidateEmail?.trim() && targetPosition?.trim();
  const hasSelectedReferents = selectedReferents.length > 0;
  const canGoNext = hasValidCandidateInfo && hasSelectedReferents;

  // Si pas de données d'analyse, rediriger vers Step1
  if (!aiAnalysisData) {
    return (
      <div className="flex justify-center">
        <div className="w-full max-w-2xl space-y-8">
          <div className="space-y-2">
            <h1 className="text-2xl font-medium font-bricolage text-gray-800">Aucune donnée d'analyse disponible</h1>
            <p className="text-sm font-normal font-bricolage text-neutral-400">
              L'analyse IA n'a pas encore été effectuée. Retournez à l'étape précédente.
            </p>
          </div>

          <div className="flex flex-col items-center justify-center py-12 space-y-4">
            <Brain className="h-12 w-12 text-neutral-400" />
            <div className="text-center">
              <p className="text-neutral-400 text-sm font-normal font-bricolage mb-4">
                Veuillez retourner à l'étape précédente pour déclencher l'analyse IA.
              </p>
              <Button onClick={onPrevious} variant="outline" className="font-bricolage">
                Retour à la configuration
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const candidateInfo = aiAnalysisData?.candidateInfo || {};
  const targetPositionAI = aiAnalysisData?.targetPosition || '';
  const experiences = aiAnalysisData?.experiences || [];
  const recommendedReferents = aiAnalysisData?.recommendedReferents || [];

  // Fonction pour basculer la sélection d'un référent
  const toggleReferentSelection = (referentId: string) => {
    const newSelection = selectedReferents.includes(referentId) 
      ? selectedReferents.filter(id => id !== referentId)
      : [...selectedReferents, referentId];
    
    setSelectedReferents(newSelection);
    
    // Synchroniser avec le formulaire - stocker les objets référents complets
    const selectedReferentObjects = recommendedReferents.filter((ref: RecommendedReferent, index: number) => {
      const refId = ref.experienceId || index.toString();
      return newSelection.includes(refId);
    });
    selectedReferentsField.onChange(selectedReferentObjects);
  };

  // Fonction pour obtenir le badge de priorité
  const getPriorityBadge = (priority: number) => {
    const priorityColors = {
      1: 'bg-teal-400/10 text-teal-400',
      2: 'bg-yellow-400/10 text-yellow-400',
      3: 'bg-red-400/10 text-red-400'
    };
    
    return (
      <div className={`px-2 py-1 rounded-lg flex justify-center items-center ${priorityColors[priority as keyof typeof priorityColors] || priorityColors[3]}`}>
        <div className="text-xs font-normal font-['Inter']">Priorité {priority}</div>
      </div>
    );
  };

  return (
    <div className="flex justify-center">
      <div className="w-full max-w-2xl space-y-6">
        {/* Header */}
        <div className="space-y-2">
          <h1 className="text-2xl font-medium font-bricolage text-gray-800">
            Validation des données extraites
          </h1>
          <p className="text-sm font-normal font-bricolage text-neutral-400">
            Vérifiez et modifiez si nécessaire les informations extraites par l'IA.
          </p>
        </div>

        {/* Informations du candidat */}
        <CandidateInfoSection 
          control={control}
          candidateInfo={candidateInfo}
          targetPositionAI={targetPositionAI}
        />

        {/* Expériences clés extraites */}
        <div className="space-y-3">
          <h3 className="text-gray-800 text-base font-medium font-bricolage">
            Expériences clés extraites
          </h3>
          <div className="p-4 rounded-[10px] border border-neutral-400/20 space-y-4">
            {experiences.length > 0 ? (
              experiences.map((experience: Experience, index: number) => (
                <div key={index} className="space-y-1">
                  <div className="text-black text-sm font-medium font-bricolage">
                    {experience.position}
                  </div>
                  <div className="text-neutral-400 text-xs font-normal font-bricolage">
                    {experience.company}
                  </div>
                </div>
              ))
            ) : (
              <div className="text-neutral-400 text-sm font-medium font-bricolage">
                Aucune expérience extraite
              </div>
            )}
          </div>
        </div>

        {/* Référents recommandés par l'IA */}
        <div className="space-y-3">
          <div className="space-y-2">
            <h3 className="text-gray-800 text-base font-medium font-bricolage">
              Référents recommandés par l'IA ({recommendedReferents.length})
            </h3>
            <p className="text-neutral-400 text-xs font-normal font-bricolage">
              L'IA a identifié ces référents potentiels basés sur les expériences les plus pertinentes. Sélectionnez ceux que vous souhaitez inclure dans votre campagne.
            </p>
          </div>
          <div className="p-4 rounded-[10px] border border-neutral-400/20 space-y-4">
            {recommendedReferents.length > 0 ? (
              recommendedReferents.map((referent: RecommendedReferent, index: number) => {
                const isSelected = selectedReferents.includes(referent.experienceId || index.toString());
                return (
                  <div key={referent.experienceId || index} className="space-y-2">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-2">
                        <div 
                          className="cursor-pointer"
                          onClick={() => toggleReferentSelection(referent.experienceId || index.toString())}
                        >
                          {isSelected ? (
                            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect y="0.5" width="16" height="16" rx="4.8" fill="#40E0D0"/>
                              <path d="M4.32471 9.27949L6.77471 11.7295L11.6747 6.47949" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          ) : (
                            <div className="w-4 h-4 bg-white rounded-[4.80px] border border-neutral-400/20"></div>
                          )}
                        </div>
                        <div className="text-gray-800 text-sm font-medium font-bricolage">
                          {referent.experienceRef || `${referent.suggestedRole} - ${referent.experienceId}`}
                        </div>
                      </div>
                      {getPriorityBadge(referent.priority || 1)}
                    </div>
                    {referent.suggestedRole && (
                      <div className="text-neutral-400 text-xs font-normal font-bricolage ml-6">
                        Rôle suggéré: {referent.suggestedRole}
                      </div>
                    )}
                    <div className="text-neutral-400 text-xs font-normal font-bricolage ml-6">
                      {referent.reasoning || 'Référent recommandé par l\'IA'}
                    </div>
                    {index < recommendedReferents.length - 1 && (
                      <div className="border-t border-neutral-400/20 mt-4"></div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="text-neutral-400 text-sm font-medium font-bricolage">
                Aucun référent recommandé
              </div>
            )}
          </div>
        </div>

        {/* Message d'aide si aucun référent n'est sélectionné */}
        {!hasSelectedReferents && (
          <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <div className="text-amber-800 text-sm font-medium font-bricolage">
              Sélection requise
            </div>
            <div className="text-amber-700 text-sm font-bricolage mt-1">
              Veuillez sélectionner au moins un référent pour continuer vers l'étape suivante.
            </div>
          </div>
        )}

        {/* Boutons de navigation */}
        <div className="flex justify-between items-center pt-6">
          <Button
            onClick={onPrevious}
            variant="outline"
            className="h-10 px-5 py-3 rounded-[10px] font-bricolage"
          >
            Précédent
          </Button>
          <Button
            onClick={onNext}
            disabled={!canGoNext}
            className="h-10 px-5 py-3 bg-teal-400 hover:bg-teal-500 rounded-[10px] disabled:opacity-50 disabled:cursor-not-allowed font-bricolage"
          >
            Suivant
          </Button>
        </div>
      </div>
    </div>
  );
};